/* Plot & Harvest header (v2 3-10-2026, search dropdown v2): sticky sizing, mega menu, predictive search, mobile drawer, basket count */
(function () {
  'use strict';
  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  function fmt(v) { var n = typeof v === 'string' ? parseFloat(v) : v / 100; try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: CUR }).format(n); } catch (e) { return '£' + n.toFixed(2); } }

  /* ---- shared search helpers (also used by ph-search.js) ---- */
  (function () {
    var el = document.querySelector('[data-ph-problems]'), list = [];
    try { list = el ? JSON.parse(el.textContent) : []; } catch (e) { list = []; }
    list.forEach(function (p) { p.k = (p.k || []).map(function (k) { return String(k).trim().toLowerCase(); }).filter(Boolean); p.rel = (p.rel || []).map(function (k) { return String(k).trim(); }).filter(Boolean); });
    window.PHProblems = list;
    window.PHProblemFor = function (term) {
      term = String(term || '').toLowerCase().trim(); if (term.length < 3) return null;
      var words = term.split(/[^a-z0-9]+/).filter(function (w) { return w.length >= 3; });
      for (var i = 0; i < list.length; i++) {
        var ks = list[i].k;
        for (var j = 0; j < ks.length; j++) {
          var k = ks[j];
          if (term === k || term.indexOf(k) > -1) return list[i];
          if (k.indexOf(' ') < 0) { for (var w = 0; w < words.length; w++) { if (k.indexOf(words[w]) === 0 && words[w].length >= Math.min(3, k.length)) return list[i]; } }
          else if (term.indexOf(' ') > -1 && term.length >= 5 && k.indexOf(term) === 0) return list[i];
        }
      }
      return null;
    };
    window.PHHighlight = function (root, term) {
      var words = String(term || '').toLowerCase().split(/\s+/).filter(function (w) { return w.length >= 2; }).map(function (w) { return w.length > 4 ? w.replace(/(es|s)$/, '') : w; });
      if (!words.length) return;
      var re = new RegExp('(' + words.map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')', 'ig');
      Array.prototype.forEach.call(root.querySelectorAll('[data-hl]'), function (n) {
        if (n.getAttribute('data-hl-done')) return;
        n.innerHTML = n.textContent.replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }).replace(re, '<mark>$1</mark>');
        n.setAttribute('data-hl-done', '1');
      });
    };
  })();

  $$('[data-ph-hdr]').forEach(function (hdr) {
    var section = hdr.closest('.shopify-section') || hdr.parentNode;
    var top = $('[data-top]', hdr), bar = $('[data-bar]', hdr);

    /* ---- sizes: top bar scrolls away, the rest stays; other sections read --header-height ---- */
    function measure() {
      var th = top ? top.offsetHeight : 0, bh = bar ? bar.offsetHeight : 0;
      section.style.setProperty('--ph-top-h', th + 'px');
      document.body.style.setProperty('--header-height', bh + 'px');
      document.body.style.setProperty('--header-group-height', (th + bh) + 'px');
    }
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(hdr); else window.addEventListener('resize', measure);

    /* ---- mega menu ---- */
    var links = $$('[data-mega-link]', hdr), openId = null, tOpen = null, tClose = null;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    function panel(id) { return $('[data-mega="' + id + '"]', hdr); }
    function link(id) { return $('[data-mega-link="' + id + '"]', hdr); }
    function open(id) {
      if (openId === id) return;
      close();
      var p = panel(id), l = link(id); if (!p || !l) return;
      p.hidden = false; l.setAttribute('aria-expanded', 'true'); openId = id;
    }
    function close() {
      if (openId === null) return;
      var p = panel(openId), l = link(openId);
      if (p) p.hidden = true; if (l) l.setAttribute('aria-expanded', 'false');
      openId = null;
    }
    links.forEach(function (l) {
      var id = l.getAttribute('data-mega-link');
      l.addEventListener('mouseenter', function () { if (!fine.matches) return; clearTimeout(tClose); clearTimeout(tOpen); tOpen = setTimeout(function () { open(id); }, openId === null ? 120 : 0); });
      l.addEventListener('mouseleave', function () { clearTimeout(tOpen); tClose = setTimeout(close, 220); });
      l.addEventListener('click', function (e) { if (openId !== id) { e.preventDefault(); open(id); } });
      l.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); open(id); var f = $('a', panel(id)); if (f) f.focus(); }
      });
    });
    $$('[data-mega]', hdr).forEach(function (p) {
      p.addEventListener('mouseenter', function () { clearTimeout(tClose); });
      p.addEventListener('mouseleave', function () { if (fine.matches) tClose = setTimeout(close, 220); });
      p.addEventListener('focusout', function (e) { var id = p.getAttribute('data-mega'); if (!p.contains(e.relatedTarget) && e.relatedTarget !== link(id)) close(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openId !== null) { var l = link(openId); close(); if (l) l.focus(); }
    });
    document.addEventListener('click', function (e) { if (openId !== null && !e.target.closest('.ph-hdr__nav')) close(); });

    /* ---- predictive search (v2): suggestions + ranges | problem solver + products ---- */
    var form = $('[data-search]', hdr), q = $('[data-q]', hdr), box = $('[data-sugg]', hdr), clr = $('[data-q-clear]', hdr), tq = null, ctl = null, sel = -1, last = '';
    if (form && q) {
      /* product-only results + clear button (added here so the header markup stays as it is) */
      if (!form.querySelector('input[name="type"]')) { var ti = document.createElement('input'); ti.type = 'hidden'; ti.name = 'type'; ti.value = 'product'; form.appendChild(ti); }
      if (!clr) {
        clr = document.createElement('button'); clr.type = 'button'; clr.className = 'ph-hdr__search-x'; clr.setAttribute('aria-label', 'Clear search'); clr.setAttribute('data-q-clear', '');
        clr.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        var go = form.querySelector('.ph-hdr__search-go'); form.insertBefore(clr, go || box);
      }
      clr.hidden = !q.value;
    }
    function hide() { if (!box) return; box.hidden = true; q.setAttribute('aria-expanded', 'false'); q.removeAttribute('aria-activedescendant'); sel = -1; }
    function items() { return $$('[role="option"]', box); }
    function mark(i) {
      var it = items(); if (!it.length) return;
      sel = (i + it.length) % it.length;
      it.forEach(function (a, k) { a.setAttribute('aria-selected', k === sel ? 'true' : 'false'); });
      q.setAttribute('aria-activedescendant', it[sel].id); it[sel].scrollIntoView({ block: 'nearest' });
    }
    function probFor(term) { return window.PHProblemFor ? window.PHProblemFor(term) : null; }
    function probBox(p) {
      var h = '<div class="ph-pd__prob"><p class="ph-pd__prob-k">Problem solver</p><p class="ph-pd__prob-q">' + esc(p.q || p.h) + '</p><div class="ph-pd__prob-c">';
      (p.o || []).forEach(function (o, i) { h += '<a role="option" id="ph-o-s' + i + '" href="' + esc(o.u) + '">' + esc(o.c) + '</a>'; });
      return h + '</div></div>';
    }
    function run() {
      var term = q.value.trim();
      if (clr) clr.hidden = !q.value;
      if (term.length < 2) { hide(); return; }
      if (term === last && box.innerHTML) { box.hidden = false; q.setAttribute('aria-expanded', 'true'); return; }
      if (ctl) ctl.abort(); ctl = window.AbortController ? new AbortController() : null;
      var url = ROOT + 'search/suggest?q=' + encodeURIComponent(term) + '&resources[type]=query,collection,product&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=ph-predictive';
      fetch(url, ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html'), pd = $('[data-pd]', d), p = probFor(term);
        var hasAny = pd && +pd.getAttribute('data-n') > 0;
        var h = '';
        if (pd && (hasAny || p)) {
          if (p) { var slot = $('[data-pd-problem]', pd); if (slot) slot.innerHTML = probBox(p); }
          if (!$('.ph-pd__l', pd)) pd.classList.add('ph-pd--one');
          h = pd.outerHTML;
        } else {
          h = '<p class="ph-sugg__none">No matches for “' + esc(term) + '”. Try a shorter word, like “cage” or “arch”.</p>';
        }
        h += '<div class="ph-pd__foot"><a class="ph-pd__all" role="option" id="ph-o-all" href="' + ROOT + 'search?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last&type=product">See all results for “' + esc(term) + '” <span aria-hidden="true">→</span></a>' +
          '<span class="ph-pd__keys" aria-hidden="true"><kbd>↑</kbd><kbd>↓</kbd> move <kbd>Enter</kbd> open <kbd>Esc</kbd> close</span></div>';
        box.innerHTML = h;
        if (window.PHHighlight) window.PHHighlight(box, term);
        last = term; box.hidden = false; q.setAttribute('aria-expanded', 'true'); sel = -1;
      }).catch(function () {});
    }
    if (form && q && box) {
      q.addEventListener('input', function () { clearTimeout(tq); tq = setTimeout(run, 160); if (clr) clr.hidden = !q.value; });
      q.addEventListener('focus', function () { if (q.value.trim().length >= 2) run(); });
      q.addEventListener('keydown', function (e) {
        if (box.hidden) { if (e.key === 'ArrowDown' && q.value.trim().length >= 2) { e.preventDefault(); run(); } return; }
        if (e.key === 'ArrowDown') { e.preventDefault(); mark(sel + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); mark(sel - 1); }
        else if (e.key === 'Enter' && sel >= 0) { e.preventDefault(); location.href = items()[sel].href; }
        else if (e.key === 'Escape') { hide(); }
      });
      if (clr) clr.addEventListener('click', function () { q.value = ''; clr.hidden = true; hide(); q.focus(); });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
      form.addEventListener('submit', function (e) { if (!q.value.trim()) { e.preventDefault(); q.focus(); } });
    }

    /* ---- mobile drawer ---- */
    var drawer = $('[data-drawer]', hdr), opener = $('[data-drawer-open]', hdr);
    function dOpen() {
      drawer.hidden = false; opener.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('ph-drawer-open');
      var x = $('.ph-drawer__x', drawer); if (x) x.focus();
    }
    function dClose() {
      drawer.hidden = true; opener.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('ph-drawer-open'); opener.focus();
    }
    if (drawer && opener) {
      opener.addEventListener('click', dOpen);
      $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', dClose); });
      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { dClose(); return; }
        if (e.key !== 'Tab') return;
        var f = $$('a[href], button, summary', $('[data-drawer-panel]', drawer)).filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
      window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches && !drawer.hidden) dClose(); });
    }

    /* ---- basket count from ph-* sections ---- */
    document.addEventListener('cart:update', function (e) {
      var d = e.detail || {}, n = d.data && typeof d.data.itemCount === 'number' ? d.data.itemCount : (d.resource && d.resource.item_count);
      if (typeof n !== 'number') return;
      $$('[data-ph-count]', hdr).forEach(function (c) { c.textContent = n; c.hidden = n === 0; });
    });
  });
})();
